import { render, staticRenderFns } from "./M_asset.vue?vue&type=template&id=fdb2fe90&scoped=true&xmlns=true&"
import script from "./M_asset.vue?vue&type=script&lang=js&"
export * from "./M_asset.vue?vue&type=script&lang=js&"
import style0 from "./M_asset.vue?vue&type=style&index=0&id=fdb2fe90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb2fe90",
  null
  
)

export default component.exports